<template>
	<sf-modal-layout class="qms-xxl" :title="cmpnMstPopupInfo.title" :show="display" :closeModal="close">
		<div class="h-100">
			<div class="sf-col-30">
				<template v-if="!isLoading">
					<sf-card class="p-0 border-0 bg-transparent h-100">
						<cmpn-mst-popup-table
							ref="table"
							:scrId="scrId"
							:sendParam2="sendParam2"
							@OpenComCodePopup="OpenComCodePopup"
							:sendParam3="sendParam3"
							@OpenPopupPartNo="OpenPopupPartNo"
							@OpenPopupCausCd="OpenPopupCausCd"
							@Refresh="Refresh"
							@RefreshMst="RefreshMst"
							@close="close"
							:sendParam1="sendParam1"
							@OpenCmpnPopup="OpenCmpnPopup"
						></cmpn-mst-popup-table>
					</sf-card>
					<sf-card class="p-0 border-0 bg-transparent">
						<cmpn-op-table :scrId="scrId" :tab="getMessage_('QWCC001538')"></cmpn-op-table>
					</sf-card>
				</template>
			</div>
		</div>
		<!--업체명 팝업-->
		<comp-popup ref="compPopup" @SendData="sendData1" @Refresh="Refresh" :scrId="scrId"></comp-popup>
		<!--공통코드 팝업(현상코드) || 원인코드-->
		<com-cd-popup ref="comCdPopup" @SendData="sendData2" @Refresh="Refresh" :scrId="scrId"></com-cd-popup>
		<!--원인부품팝업-->
		<part-popup ref="partPopup" @SendPartData="sendData3" @Refresh="Refresh" :scrId="scrId" />
		<!--교환부품정보팝업-->
		<cmpn-part-list
			ref="cmpnPartList"
			@Refresh="Refresh"
			:scrId="scrId"
			@OpenGridOpPopup="OpenGridOpPopup"
			@OpenGridPartPopup="OpenGridPartPopup"
			:sendParam4="sendParam4"
		></cmpn-part-list>
		<!--그리드 AS원인부품팝업-->
		<part-popup ref="partGridPopup" @SendPartData="sendData4" @Refresh="Refresh" :scrId="scrId" />

		<!--그리드 OP코드 팝업-->
		<!-- <op-cd-popup ref="opCdPopup" @SendData="sendData" @Refresh="Refresh" :scrId="scrId" /> -->
	</sf-modal-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import PartPopup from '@qms/comm/commpopup/PartPopup/PartPopup.vue';
import CompPopup from '@/views/qms/comm/commpopup/CompPopup/CompPopup.vue';
import ComCdPopup from '@/views/qms/comm/commpopup/ComCdPopup/ComCdPopup.vue';
import CmpnMstPopupTable from './Table/CmpnMstPopupTable.vue';
import CmpnOpTable from './Table/CmpnOpTable.vue';
import cmpnPartList from './Tab/OPCode/Popup/CmpnPartList.vue';
//import OpCdPopup from './Popup/OpCdPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			initState: false,
			display: false,
			isLoading: false,
			cmpnMstPopupInfo: {
				title: '',
				cmpnNo: ''
			},
			sendParam1: {}, //업체명팝업
			sendParam2: {}, //공통코드팝업
			sendParam3: {}, //원인부품팝업
			sendParam4: {} //그리드품번팝업
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	components: {
		CmpnMstPopupTable,
		CompPopup,
		ComCdPopup,
		PartPopup,
		CmpnOpTable,
		cmpnPartList,
		ComCdPopup
		//	OpCdPopup
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Refresh() {
			let cmpnNo = this.cmpnMstPopup.cmpnNo;
			this.getCmpnMstPopList_(cmpnNo);
		},
		RefreshMst() {
			this.$emit('Refresh');
		},
		async open(param) {
			this.display = true;
			this.isLoading = true;
			this.$sf_toggleLoading(true);

			this.cmpnMstPopupInfo.title = param.title;
			this.cmpnMstPopupInfo.cmpnNo = param.cmpnNo;

			let cmpnNo = this.cmpnMstPopupInfo.cmpnNo;

			//초기화
			this.setCmpnMstInit_();
			try {
				if (cmpnNo) {
					this.$sf_toggleLoading(true);
					this.isLoading = true;
					await this.getCmpnMstPopList_(cmpnNo);
				}
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message
				});
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}
		},
		close() {
			this.isLoading = true;
			this.display = false;
			this.$emit('Refresh');
		},
		OpenCmpnPopup(param) {
			this.$refs.compPopup.open(param); //.open(param);
		},
		OpenComCodePopup(param) {
			this.$refs.comCdPopup.open(param); //.open(param);
		},
		OpenPopupCausCd(param) {
			this.$refs.comCdPopup.open(param); //.open(param);
		},
		OpenPopupPartNo(param) {
			this.$refs.partPopup.open(param); //.open(param);
		},
		OpenGridPartPopup(param) {
			this.$refs.partGridPopup.open(param.partNo); //.open(param);
		},
		OpenGridOpPopup(commCd) {
			this.$refs.opCdPopup.open(commCd); //.open(param);
		},
		sendData1(param) {
			this.sendParam1 = param;
		},
		sendData2(param) {
			// if (param.commCdType == 'OP_CD') {
			// 	this.$refs.cmpnPartList.gridOpCdPopUp(param);
			// } else
			if (param.commCdType == 'CAUS_CD') {
				this.setCmpnMstPopup_({ key: 'causCd', value: param.commCd });
				this.setCmpnMstPopup_({ key: 'causNm', value: param.commCdName });
			} else {
				this.sendParam2 = param;
			}
		},
		sendData3(param) {
			//원인부품 팝업 데이터 내려옴
			this.$refs.table.compSet(param);
			this.sendParam3 = param;
		},
		sendData4(param) {
			this.$refs.cmpnPartList.gridParNoPopUp(param);
			this.sendParam4 = param; //watch감시용
		},
		saveAction() {}
	}
};
</script>

<style>
.el-dialog.sf-modal.xl {
	width: 98%;
	height: 98%;
}
.el-dialog__wrapper {
	top: 50px;
}
.el-dialog.sf-modal.xl .el-dialog__body {
	max-height: 98%;
}
</style>
